import { yupResolver } from '@hookform/resolvers/yup';
import { useRef } from 'react';

import { Button, Form, Link } from '@appsumo/dorado-react';
import { useSubmitReply } from '~/lib/util/hooks/submitReply';
import { YupReplySchema } from '~/types/question-review';
import { REPLY_MAX_LENGTH } from '~/lib/discussions/constants';
import { useReviewStats } from '~/hooks/userReviewStats';

interface SubmitReplyProps {
  comment?: any;
  type: 'dealcomment' | 'dealreview';
  dealId: number;
  mutateComment?: Function;
}

export function SubmitReply({
  type,
  comment,
  dealId,
  mutateComment,
}: Readonly<SubmitReplyProps>): JSX.Element {
  const formRef = useRef<HTMLFormElement>(null);
  const { mutateReviewStats } = useReviewStats(comment.deal_id);
  const { handleSubmit, isLoading } = useSubmitReply({
    type,
    mutateComment,
    mutateReviewStats,
    comment,
    dealId,
    formRef,
  });

  return (
    <div className="w-full" data-testid="review-submit-reply">
      <Form
        resolver={yupResolver(YupReplySchema)}
        onSubmit={handleSubmit}
        ref={formRef}
      >
        <Form.TextArea
          // @ts-ignore -- TODO: add this type to dorado-react
          rows={5}
          name="comment"
          label="Your reply"
          maxLength={REPLY_MAX_LENGTH}
        />

        <Button
          type="submit"
          className="my-4 w-full"
          primary
          disabled={isLoading}
        >
          Submit reply
        </Button>

        <div className="text-sm">
          By submitting, I agree to&nbsp;
          <Link href="/community-guidelines/" styled>
            AppSumo&apos;s Community Guidelines.
          </Link>
        </div>
      </Form>
    </div>
  );
}
